import { Title } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { SlideTextContainer } from "../../components/SlideTextContainer";
import { type EducationSlide } from "../types";
import { JOB_CARDS, JobCard } from "./JobCard";

interface JobCardsSlideProps {
  slide: EducationSlide;
}

export function JobCardsSlide(_props: JobCardsSlideProps) {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 58,
          position: "relative",
          overflow: "hidden",
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: 293 }}>
          <Stack spacing="10.3px">
            {JOB_CARDS.map((card) => (
              <JobCard key={card.workplace} data={card} />
            ))}
          </Stack>
        </Box>
        <Box
          sx={(theme) => ({
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "25%",
            background: `linear-gradient(to bottom, ${theme.palette.background.quaternary} 0%, rgba(250, 248, 247, 0) 75%)`,
            pointerEvents: "none",
          })}
        />
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "40%",
            background: `linear-gradient(to bottom, rgba(250, 248, 247, 0) 45%, ${theme.palette.background.quaternary} 85%)`,
            pointerEvents: "none",
          })}
        />
      </Box>

      <SlideTextContainer>
        <Stack spacing={0} alignItems="center" sx={{ margin: 0 }}>
          <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
            Compare job details
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            upfront and find your
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            ideal role
          </Title>
        </Stack>
      </SlideTextContainer>
    </Box>
  );
}
